import {
  Box,
  Button,
  Icon,
  Typography,
  TypographyProps,
} from '@branch-messenger/willow-ui'
import { ChevronRightFilled } from '@branch-messenger/willow-ui/icons'
import { ComponentPropsWithRef } from 'react'

import { TanstackButtonLink } from './TanstackButtonLink'

export type MenuButtonProps = {
  title: string
  description?: string
  showArrowRight?: boolean
  titleSize?: TypographyProps['$size']
} & ComponentPropsWithRef<typeof TanstackButtonLink>

export const MenuButton = ({
  ref,
  title,
  description,
  iconLeft,
  iconRight,
  titleSize = 'md',
  showArrowRight = true,
  ...props
}: MenuButtonProps) => {
  const isExternalLink = !!props.href
  const isButton = !props.to && !isExternalLink

  const Component = isExternalLink || isButton ? Button : TanstackButtonLink

  return (
    <Component
      as={isExternalLink ? 'a' : undefined}
      ref={ref}
      variant="link"
      color="tertiary"
      style={{
        textDecoration: 'none',
        textAlign: 'initial',
        width: '100%',
        display: 'block',
      }}
      {...props}
    >
      <Box $display="flex" $justify="space-between" $gap={2} $fullWidth>
        <Box $display="flex" $flex={1} $gap={4}>
          {iconLeft && (
            <Box $flexShrink={0} $display="flex" $align="center">
              {iconLeft}
            </Box>
          )}
          <Box
            $display="flex"
            $direction="column"
            $align="initial"
            $gap={1}
            $flex={1}
          >
            <Typography $size={titleSize} $bold>
              {title}
            </Typography>
            {!!description && <Typography $size="xs">{description}</Typography>}
          </Box>
        </Box>
        {showArrowRight && (
          <Icon Icon={ChevronRightFilled} size={6} style={{ flexShrink: 0 }} />
        )}
        {iconRight && (
          <Box $flexShrink={0} $display="flex" $align="center">
            {iconRight}
          </Box>
        )}
      </Box>
    </Component>
  )
}

MenuButton.displayName = 'MenuButton'
